import GalleryDescriptionContainer from "../../../../Components/Miscellaneous/Gallery/GalleryDescription/GalleryDescriptionContainer";

const GalleryDescription = () => {
  return <GalleryDescriptionContainer />;
};

export default GalleryDescription;
